import React from 'react';
import Header from './Header';

const Page3 = () => {
  return (
    <div>
      <Header />
      <h1>Page 3</h1>
      <p>This is the content of Page 3.</p>
      <iframe src="https://192.168.10.31/" width="100%" height="600"></iframe>
      {/* <iframe src="https://192.168.10.15:8006/" width="100%" height="600"></iframe> */}
      {/* <iframe src="https://192.168.10.32/" width="100%" height="600"></iframe> */}
      {/* <iframe src="https://192.168.10.30/" width="100%" height="600"></iframe> */}



    </div>
  );
};

export default Page3;
